<template>
  <div class="task-log-main-window">
    <div class="tag-table">
      <div class="table-responsive">
        <!--        <strong>-->
        <!--          {{ task.task_assignment[0].updated_at | shortDate }}-->
        <!--          {{ task.task_assignment[0].updated_at | shortTime }}-->
        <!--          {{ task.task_assignment[0].assigned_by.full_name }}www.txt</strong-->
        <!--        >-->
        <!--        <span class="ratio-label"-->
        <!--          >Replied:-->
        <!--          <span class="number-replied">{{ countHowManyReplied.length }}</span-->
        <!--          >/{{ task.task_assignment.length - 1 }}</span-->
        <!--        >-->
        <!--        <table class="table table-condensed">-->
        <!--          <tbody>-->
        <!--            <tr-->
        <!--              v-for="(log, idx) in filterTaskCreator(-->
        <!--                task.task_assignment.slice().reverse()-->
        <!--              )"-->
        <!--              :key="idx"-->
        <!--            >-->
        <!--              <td>{{ log.updated_at | shortDate }}</td>-->
        <!--              <td>{{ log.updated_at | shortTime }}</td>-->
        <!--              <td>{{ log.assigned_by.full_name }}</td>-->
        <!--              <td>{{ log.assigned_to.full_name }}</td>-->
        <!--              <td>{{ task.task_type.title }}</td>-->
        <!--              <td>{{ task.user_status.status_id.title }}</td>-->
        <!--              <td>{{ getEstTimeOfTask(task.start_time, task.end_time) }}</td>-->
        <!--              <td>{{ getTotalTimeDurationOfTaskPerUser(log) }}</td>-->
        <!--              <td>-->
        <!--                <span v-if="findUser(log.assigned_to.id) !== undefined">-->
        <!--                  |-->
        <!--                </span>-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <span v-if="findUser(log.assigned_to.id) !== undefined">{{-->
        <!--                  formatDate(findUser(log.assigned_to.id).created_at)-->
        <!--                }}</span>-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <span v-if="findUser(log.assigned_to.id) !== undefined"-->
        <!--                  ><i class="far fa-check-circle success "></i-->
        <!--                ></span>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <hr />-->
        <!--            <tr-->
        <!--              v-for="(conversation, idx) in task.task_conversation_count"-->
        <!--              :key="conversation.id"-->
        <!--            >-->
        <!--              <td>{{ conversation.updated_at | shortDate }}</td>-->
        <!--              <td>{{ conversation.updated_at | shortTime }}</td>-->
        <!--              <td>{{ conversation.from_name }}</td>-->
        <!--              <td>{{ conversation.to_name }}</td>-->
        <!--              <td>Task</td>-->
        <!--              <td>Conversation</td>-->
        <!--              <td>#{{ idx + 1 }}</td>-->
        <!--            </tr>-->
        <!--          </tbody>-->
        <!--        </table>-->
        <table class="table table-condensed">
          <tbody>
            <tr
              v-for="(log, idx) in task.task_process_log.slice().reverse()"
              :key="idx"
            >
              <td>{{ log.updated_at | shortDate }}</td>
              <td>{{ log.updated_at | shortTime }}</td>
              <td>{{ log.from_user.full_name }}</td>
              <td>{{ log.to_user.full_name }}</td>
              <td :title="log.asset">
                <strong>{{ log.asset.toLowerCase() | truncate(15) }}</strong>
              </td>
              <td style="white-space: nowrap">
                {{ task.user_status.status_id.title }}
              </td>
              <td style="white-space: nowrap">
                {{ getEstTimeOfTask(task.start_time, task.end_time) }}
              </td>
              <td>{{ getTotalTimeDurationOfTaskPerUser(log) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TaskLogMainTaskWindow",
  props: {
    task: {
      type: Object
    }
  },
  data() {
    return {
      taskReplies: [],
      countHowManyReplied: 0,
      name: null
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      let korsy = string.toLowerCase();
      return korsy.charAt(0).toUpperCase() + string.slice(1);
    },
    filterTaskCreator(assignments) {
      return assignments.filter(
        assigned => assigned.assigned_to.id !== assigned.assigned_by.id
      );
    },
    findUser(userId) {
      return this.taskReplies.find(reply => reply.reply_by === userId);
    },
    getEstTimeOfTask(start, end) {
      let duration = moment.duration(moment(end).diff(start));
      // let hours = duration.asHours();
      let time = duration.humanize();
      return time;
    },
    getTotalTimeDurationOfTaskPerUser(log) {
      let timer = this.task.task_time_duration.find(
        timer => timer.user_id === log.from_user.id
      );
      if (timer) {
        return timer.time;
      } else {
        return " ";
      }
    }
  }
};
</script>

<style scoped>
.task-log-main-window {
  height: 100%;
}
.table-condensed {
  font-size: 13px;
}
</style>
